import React from 'react';
import {
    BarChart3,
    DollarSign,
    TrendingUp,
    Zap
} from 'lucide-react';

export const COLORS = {
    primary: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    purple: '#8B5CF6',
    indigo: '#6366F1',
    pink: '#EC4899',
    teal: '#14B8A6',
    orange: '#F97316',
    cyan: '#06B6D4'
};

export const CHART_COLORS = [
    COLORS.primary,
    COLORS.success,
    COLORS.purple,
    COLORS.warning,
    COLORS.indigo,
    COLORS.pink,
    COLORS.teal,
    COLORS.orange,
    COLORS.cyan,
    COLORS.danger
];

export const formatRevenue = (value) => {
    if (value >= 1e9) return `$${(value / 1e9).toFixed(2)}B`;
    if (value >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
    if (value >= 1e3) return `$${(value / 1e3).toFixed(1)}K`;
    return `$${value}`;
};

export function TabButton({ active, onClick, icon, label }) {
    return (
        <button
            onClick={onClick}
            className={`
                flex items-center space-x-2 px-4 py-2 rounded-md font-medium transition-all
                ${active
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'text-gray-600 hover:bg-gray-100'
                }
            `}
        >
            {icon}
            <span>{label}</span>
        </button>
    );
}

export function MetricCard({ icon, title, value, subtitle, color = 'blue' }) {
    const colorClasses = {
        blue: 'bg-blue-50 text-blue-700',
        green: 'bg-green-50 text-green-700',
        purple: 'bg-purple-50 text-purple-700',
        orange: 'bg-orange-50 text-orange-700'
    };

    return (
        <div className="bg-white rounded-lg shadow p-4 flex items-center space-x-4">
            <div className={`p-3 rounded-full ${colorClasses[color] || colorClasses.blue}`}>
                {icon}
            </div>
            <div>
                <p className="text-sm text-gray-500">{title}</p>
                <p className="text-2xl font-bold text-gray-900">{value}</p>
                <p className="text-sm text-gray-500">{subtitle}</p>
            </div>
        </div>
    );
}

export function ChartCard({ title, subtitle, children, fullWidth }) {
    return (
        <div className={`bg-white rounded-lg shadow p-4 ${fullWidth ? 'col-span-full' : ''}`}>
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                    {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
                </div>
            </div>
            {children}
        </div>
    );
}

export function EmptyState({ message = "No data available" }) {
    return (
        <div className="flex items-center justify-center h-64 text-gray-400">
            <p>{message}</p>
        </div>
    );
}
